export default function ChatInputAreaPlaceholder() {
  return (
    <div className="whitespace-nowrap truncate">
      Press <kbd>Enter</kbd> to send, <kbd>Shift</kbd>+<kbd>Enter</kbd> for new line
    </div>
  );
}
